
import { ECameraType } from '~/domain/ECameraType';

export const views = [{
  code: 'feature',
  name: 'Feature Shots',
  types: [ECameraType.FEATURE_EXT, ECameraType.FEATURE_INT],
}, {
  code: 'ext-360',
  name: 'Exterior Environmental 360°',
  types: [ECameraType.EXT_ENV_360],
}, {
  code: 'ext-360',
  name: 'Exterior Studio 360°',
  types: [ECameraType.EXT_STUDIO_360],
}, {
  code: '36 Interior',
  name: 'Interior 360º',
  types: [ECameraType.INT_360],
},{
  code: 'pano',
  name: 'Interior Pano',
  types: [ECameraType.INT_PANO],
},{
  code: 'pano',
  name: 'Interior Studio Pano Seats Up',
  types: [ECameraType.INT_PANO_STUDIO_SEATS_UP],
},{
  code: 'pano',
  name: 'Interior Studio Pano Seats Down',
  types: [ECameraType.INT_PANO_STUDIO_SEATS_DOWN],
},{
  code: 'pano',
  name: 'Interior Environmental Pano Seats Up',
  types: [ECameraType.INT_PANO_ENV_SEATS_UP],
},{
  code: 'pano',
  name: 'Interior Environmental Pano Seats Down',
  types: [ECameraType.INT_PANO_ENV_SEATS_DOWN],
},{
  code: 'retailer',
  name: 'Retailer',
  types: [ECameraType.FEATURE_RETAILER],
},
];

export const featureView = views[0];
